import React from 'react';

export interface TableColumnProps {
    columnKey: string;
    header?: string;
    width?: string; // example usage: '220px', '30%', 'auto'
    visible?: boolean;
    showHeaderOnWrap?: boolean;
    actionColumn?: boolean;
    center?: boolean;
}

export const TableColumn: React.FC<TableColumnProps> = ({
    columnKey,
    header,
    width = 'auto',
    visible = true,
    showHeaderOnWrap = true,
    actionColumn = false,
    center = false,
}) => {
    return (
        <>
            {visible && (
                <div
                    key={columnKey}
                    className='table-column'
                    style={{ flexBasis: width }}
                >
                    {header}
                </div>
            )}
        </>
    );
};
